import React, { useEffect, useState } from "react";

const RECENT_KEY = "recent_profiles";

const ProfileSelector = ({ onSelect }) => {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [users, setUsers] = useState([]);

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const recent = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    setUsers(recent);
  }, []);

  const handleSubmit = async () => {
    setError("");

    if (!name || !password) {
      setError("Vui lòng nhập đầy đủ tên và mật khẩu.");
      return;
    }

    if (mode === "login") {
      const res = await fetch(
        `${API}/api/load?name=${encodeURIComponent(name)}&password=${encodeURIComponent(password)}`
      );
      if (!res.ok) {
        setError("Profile không tồn tại hoặc mật khẩu sai.");
        return;
      }
    }

    if (mode === "create") {
      const res = await fetch(`${API}/api/users`);
      const existing = await res.json();
      if (existing.includes(name)) {
        setError("Profile đã tồn tại.");
        return;
      }

      // ✅ Gửi đúng tham số new=1 để tạo mới
      const saveRes = await fetch(`${API}/api/save?name=${encodeURIComponent(name)}&new=1`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          password,
          positions: [],
        }),
      });

      if (!saveRes.ok) {
        setError("Không tạo được profile. Thử lại sau.");
        return;
      }
    }

    // ✅ Lưu local
    localStorage.setItem(`pass_${name}`, password);
    localStorage.setItem("currentProfile", name);

    // ✅ Ghi nhớ
    let recent = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    recent = [name, ...recent.filter((n) => n !== name)].slice(0, 5);
    localStorage.setItem(RECENT_KEY, JSON.stringify(recent));

    onSelect(name);
  };

  return (
    <div className="w-full h-screen min-h-screen overflow-hidden flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded shadow-md overflow-hidden mx-4">
        <h2 className="text-xl font-semibold text-center mb-4">
          {mode === "login" ? "🔐 Đăng nhập" : "✍️ Tạo profile mới"}
        </h2>

        <div className="space-y-3">
          <input
            placeholder="Tên profile"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
          <input
            type="password"
            placeholder="Mật khẩu"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        {error && <div className="text-sm text-red-600 mt-2">{error}</div>}

        <button
          onClick={handleSubmit}
          className="w-full bg-blue-600 text-white py-2 mt-4 rounded"
        >
          {mode === "login" ? "Đăng nhập" : "Tạo mới"}
        </button>

        <div className="text-center text-sm text-gray-600 mt-3">
          {mode === "login" ? (
            <>
              Chưa có profile?{" "}
              <button
                className="underline text-blue-600"
                onClick={() => {
                  setMode("create");
                  setError("");
                }}
              >
                Tạo mới
              </button>
            </>
          ) : (
            <>
              Đã có profile?{" "}
              <button
                className="underline text-blue-600"
                onClick={() => {
                  setMode("login");
                  setError("");
                }}
              >
                Đăng nhập
              </button>
            </>
          )}
        </div>

        {users.length > 0 && (
          <div className="mt-5 border-t pt-3 text-sm">
            <div className="text-gray-600 mb-1 font-medium">📌 Profile gần đây:</div>
            <div className="flex flex-wrap gap-2">
              {users.map((u, i) => (
                <button
                  key={i}
                  onClick={() => setName(u)}
                  className="px-3 py-1 bg-gray-200 hover:bg-gray-300 text-sm rounded"
                >
                  {u}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileSelector;
